"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildSubscription = exports.buildQuery = exports.buildMutation = exports.useSubscriptionFunction = exports.useLazyQueryFunction = exports.useQueryFunction = exports.mutateFunction = void 0;
const tslib_1 = require("tslib");
const client_1 = require("@apollo/client");
const components_1 = require("@apollo/client/react/components");
const react_1 = tslib_1.__importDefault(require("react"));
const client_2 = tslib_1.__importDefault(require("./client"));
const errorParser_1 = require("./errorParser");
function buildQuery({ subscribeToMoreOpts, fetchMoreOpts, defaultVariables, nextFetchPolicy, ...props }) {
    return class extends react_1.default.Component {
        render() {
            const { children, variables, onError, selfHandleError, ...restProps } = this.props;
            return (react_1.default.createElement(components_1.Query, { nextFetchPolicy: nextFetchPolicy, ...props, ...restProps, variables: Object.assign({}, defaultVariables, variables) }, (result) => {
                (0, errorParser_1.parseError)(props.query, result.error, onError || (selfHandleError ? _ => { } : undefined));
                const fetchOpts = fetchMoreOpts && fetchMoreOpts(result);
                return children(result, {
                    subscribeToMore: subscribeToMoreOpts ? () => result.subscribeToMore(subscribeToMoreOpts()) : undefined,
                    fetchMore: fetchOpts ? () => result.fetchMore(fetchOpts) : undefined,
                });
            }));
        }
    };
}
exports.buildQuery = buildQuery;
function buildMutation({ mutateOpts, variables, ...props }) {
    return class extends react_1.default.Component {
        render() {
            const { children, onError, selfHandleError, ...restProps } = this.props;
            return (react_1.default.createElement(components_1.Mutation, { variables: variables, ...props, ...restProps }, (mutate, result) => {
                (0, errorParser_1.parseError)(props.mutation, result.error, onError || (selfHandleError ? _ => { } : undefined));
                return children(args => mutate(mutateOpts ? mutateOpts(args) : args), result);
            }));
        }
    };
}
exports.buildMutation = buildMutation;
function mutateFunction({ mutation, mutateOpts, ...rest }) {
    return async (args, mutateArgs = {}, selfHandleError = false, onError) => {
        try {
            const argFn = mutateOpts ? mutateOpts : (variables) => ({ variables });
            const opts = {
                ...rest,
                ...argFn(args),
                ...mutateArgs,
                mutation,
            };
            const res = await client_2.default.getClient().mutate(opts);
            return {
                data: res.data,
                errors: res.errors,
            };
        }
        catch (e) {
            (0, errorParser_1.parseError)(mutation, e, onError || (selfHandleError ? _ => { } : undefined));
        }
        return null;
    };
}
exports.mutateFunction = mutateFunction;
function buildSubscription(props) {
    return class extends react_1.default.Component {
        render() {
            const { children, onError, selfHandleError, ...restProps } = this.props;
            return (
            // @ts-ignore
            react_1.default.createElement(components_1.Subscription, { ...props, ...restProps }, result => {
                (0, errorParser_1.parseError)(props.subscription, result.error, onError || (selfHandleError ? _ => { } : undefined));
                return children(result);
            }));
        }
    };
}
exports.buildSubscription = buildSubscription;
function useQueryFunction(doc, options) {
    return (0, client_1.useQuery)(doc, options && Object.assign(options, { client: client_2.default.getClient() }));
}
exports.useQueryFunction = useQueryFunction;
function useLazyQueryFunction(doc, options) {
    return (0, client_1.useLazyQuery)(doc, options && Object.assign(options, { client: client_2.default.getClient() }));
}
exports.useLazyQueryFunction = useLazyQueryFunction;
function useSubscriptionFunction(doc, options) {
    return (0, client_1.useSubscription)(doc, {
        ...options,
        client: client_2.default.getClient(),
    });
}
exports.useSubscriptionFunction = useSubscriptionFunction;
